const getWidth = (width: string | undefined) => {
  const numericWidth = Number(width);
  return !Number.isNaN(numericWidth) ? `${numericWidth}` : '100';
};

export default getWidth;
